import { FunctionComponent } from 'react'
import Grid from '@mui/material/Grid'
import { ObjectFieldTemplateProps } from '@rjsf/core'
import { Typography } from '@mui/material'
// eslint-disable-next-line @dxp-module/guidance/style-rules
import objectFieldTemplateStyles from './objectFieldTemplate.styles'

const ObjectFieldTemplate: FunctionComponent<
  ObjectFieldTemplateProps
> = props => {
  const styles = objectFieldTemplateStyles()

  const {
    properties,
    schema: { title },
  } = props

  return (
    <>
      {title && <Typography className={styles.title}>{title}</Typography>}
      <Grid container className={styles.container}>
        {properties?.map(field => field.content)}
      </Grid>
    </>
  )
}

export default ObjectFieldTemplate
